import { ISdcConfigs } from './../sdc-state/sdc-state.typings';

export const sdcStateConfigConstant: ISdcConfigs = {
  DEFAULT_SDC: {
    humanName: '',
    state: 'main.school.new-sdc.default-sdc',
    availableSdcViews: ['grid', 'profile'],
  },

  ATTENDANCE: {
    humanName: 'Attendance',
    state: 'main.school.new-sdc.attendance',
    availableSdcViews: ['grid', 'profile'],
  },

  MARKING_PERIOD: {
    humanName: 'Marking Period',
    state: 'main.school.new-sdc.marking-period',
    availableSdcViews: ['grid', 'profile'],
  },

  GRAD_PLANNING: {
    humanName: 'Graduation Planning',
    state: 'main.school.new-sdc.grad-planning',
    availableSdcViews: ['wizard', 'grid', 'profile'],
  },

  REGENTS_PLANNING: {
    humanName: 'Regents Planning',
    state: 'main.school.new-sdc.regents-planning',
    availableSdcViews: ['wizard', 'grid', 'profile'],
  },

  REGENTS_PREP: {
    humanName: 'Regents Prep',
    state: 'main.school.new-sdc.regents-prep',
    availableSdcViews: ['wizard', 'grid', 'profile'],
  },

  CREDIT_GAPS: {
    humanName: 'Credit Gaps',
    state: 'main.school.new-sdc.credit-gaps',
    availableSdcViews: ['wizard', 'grid', 'profile'],
  },

  PENDING_COURSE_GAP_PLAN_TABLE: {
    humanName: 'Pending Course and Gap Plans',
    state: 'main.school.program-changes-and-gap-plans',
    availableSdcViews: [],
  },

  NEXT_TERM_PLANNING_TABLE: {
    humanName: 'Next Term Planning',
    state: 'main.school.next-term-planning',
    availableSdcViews: [],
  },
};
